import { render, staticRenderFns } from "./update-atr-def.vue?vue&type=template&id=9d3c3a0c&scoped=true"
import script from "./update-atr-def.vue?vue&type=script&lang=js"
export * from "./update-atr-def.vue?vue&type=script&lang=js"
import style0 from "./update-atr-def.vue?vue&type=style&index=0&id=9d3c3a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3c3a0c",
  null
  
)

export default component.exports